import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAgencySelector from '@hooks/useAgencySelector'
import useImageLibrary, { generateUrls } from '@hooks/useImageLibrary'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import AgencyImageLibraries from '../AgencyImageLibraries'
import BrandImageLibraries from '../BrandImageLibraries'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title',
    },
  ]
}

interface PageContentProps {
  pageFilters: {},
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  // useLocation to refresh the window.location. If not used location won't reload if URL changes
  useLocation()

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { selectedAgencyId } = useAgencySelector()

  const { imageLibrariesIndexUrl } = generateUrls({}, { prefixRoute: `agencies/${selectedAgencyId}/manage` })

  const {
    callbacks: {
      createOrEditImageLibrary,
    },
  } = useImageLibrary({ owner_id: selectedAgencyId, owner_type: 'Agency' })

  return (
    <>
      <Helmet>
        <title>Image Libraries | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => createOrEditImageLibrary()} size="medium">
            Create
          </Button>
        )}
        activeTabBarItemKey="current"
        nestedNavigation
        tabBarItems={[
          {
            href: imageLibrariesIndexUrl,
            icon: faCheckCircle,
            key: 'current',
            title: 'Image Libraries',
          },
        ]}
        title="Image Libraries"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.imageLibraries.banner" />

            <AgencyImageLibraries pageFilters={pageFilters} />

            <BrandImageLibraries pageFilters={pageFilters} />
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.imageLibraries.sidebar" />

            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
